<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="name"
              label="Tên hoặc mã vị trí"
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import { AcademicLevel } from '@/plugins/api'
import { textHelpers } from '@/helpers/TextHelper'

export default {
  name: 'LocationFilter',
  data: () => ({
    type: '',
    academicLevel: '',
    academicLevels: [],
    name: '',
    locationTypes: [
      { title: 'Tòa nhà', value: 'BUILDING' },
      { title: 'Tầng', value: 'FLOOR' },
      { title: 'Phòng học', value: 'ROOM' },
      { title: 'Khu vực', value: 'AREA' }
    ]
  }),
  async created() {
    try {
      const res = await AcademicLevel.search({ _limit: -1 })
      this.academicLevels = res || []
    } catch (e) {
      console.error(e)
    }
  },
  mounted() {
    this.onFilterChanged()
  },
  methods: {
    onFilterChanged() {
      const params = {}
      if (this.type) params.type = this.type
      if (this.academicLevel) params.academicLevel = this.academicLevel
      if (this.name) params.name_contains = textHelpers.removeSpaces(this.name)
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;
  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
